import D1 from "../../images/personnel/team-2.png";
import D2 from "../../images/personnel/team-3.png";
import D3 from "../../images/personnel/team-4.jpg";
import NasifImg from "../../images/personnel/nasifhasan.png";

export const directors = [
  {
    id: "nasif",
    img: NasifImg,
    name: "Nasif Hossain",
    title: "Sourcing & Technology",
    desc: "",
  },
  {
    id: "zahirul",
    img: D1,
    name: "MD Zahirul Islam",
    title: "Operation & Admin",
    desc: "",
  },
  {
    id: "naushin",
    img: D2,
    name: "Naushin Adnin",
    title: "Administration & Marketing",
    desc: "",
  },
  {
    id: "sharif",
    img: D3,
    name: "Sharif Rayhan Hemon",
    title: "Sourcing, Planning & Merchandising",
    desc: "",
  },
];

export default directors;
